import { useGetLineStatusQuery, useGetPlantByIdQuery } from 'api';
import { LineStatus } from 'types/protein';

interface UseLineStatusParams {
  plantId: string;
  type: string;
}

export const useLineStatusInfo = ({ plantId, type }: UseLineStatusParams): {
  isLoading?: boolean;
  isFetching?: boolean;
  error?: string;
  [key: string]: unknown;
  data?: LineStatus[];
} => {
  const shouldSkip = type !== 'LINE' || !plantId;

  const { data, isLoading } = useGetLineStatusQuery(
    { plantId },
    {
      skip: shouldSkip,
      pollingInterval: 30000
    }
  );

  return { data, isLoading };
};
